import { hasCapability, type User } from "../base";

export const contractorLicense = {
  read: (user: User) => hasCapability(user, "contractorLicense.read"),
};
